import { ProductChangeLine } from "./productChangeLine";

export interface ProductChange {
    id: number;
    clientId: number;
    productId: number;
    state: string;
    createdAt: string;
    effectiveDate: string;
    creator: string;
    productChangeLines: ProductChangeLine[];
}

export class ProductChangeBuilder {
    private id: number;
    private clientId: number;
    private productId: number;
    private state: string = "";
    private createdAt: string = "";
    private effectiveDate: string = "";
    private creator: string = "";
    private productChangeLines: ProductChangeLine[] = [];

    withId(id: number): ProductChangeBuilder {
        this.id = id;
        return this;
    }

    withClientId(clientId: number): ProductChangeBuilder {
        this.clientId = clientId;
        return this;
    }

    withProductId(productId: number): ProductChangeBuilder {
        this.productId = productId;
        return this;
    }

    withState(state: string): ProductChangeBuilder {
        this.state = state;
        return this;
    }

    withCreatedAt(createdAt: string): ProductChangeBuilder {
        this.createdAt = createdAt;
        return this;
    }

    withEffectiveDate(effectiveDate: string): ProductChangeBuilder {
        this.effectiveDate = effectiveDate;
        return this;
    }

    withCreator(creator: string): ProductChangeBuilder {
        this.creator = creator;
        return this;
    }

    withProductChangeLine(line: ProductChangeLine): ProductChangeBuilder {
        this.productChangeLines.push(line);
        return this;
    }

    build(): ProductChange {
        return {
            id: this.id,
            clientId: this.clientId,
            productId: this.productId,
            state: this.state,
            createdAt: this.createdAt,
            effectiveDate: this.effectiveDate,
            creator: this.creator,
            productChangeLines: this.productChangeLines
        };
    }
}
